import { useState } from "react";
import { Alert, Button, Typography } from "antd";
import { useT } from "../i18n/context";

const { Text } = Typography;

interface PendingApproval {
  toolUseId: string;
  toolName: string;
  input: unknown;
}

interface ApprovalPanelProps {
  approvals: PendingApproval[];
  onApprove: (toolUseId: string) => void;
  onDeny: (toolUseId: string) => void;
}

export default function ApprovalPanel({
  approvals,
  onApprove,
  onDeny,
}: ApprovalPanelProps) {
  const [expandedId, setExpandedId] = useState<string | null>(null);
  const t = useT();

  if (approvals.length === 0) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: 56,
        right: 16,
        zIndex: 50,
        background: "var(--lude-im-bg-secondary)",
        border: "1px solid var(--lude-im-warning)",
        borderRadius: 10,
        padding: "12px 16px",
        minWidth: 240,
        maxWidth: 360,
        boxShadow: "0 4px 16px rgba(0,0,0,0.3)",
      }}
    >
      <Alert
        type="warning"
        showIcon
        message={t("approval.pending_count", { n: approvals.length })}
        style={{ marginBottom: 8, padding: "4px 8px", fontSize: 12 }}
      />
      {approvals.map((a) => {
        const isOpen = expandedId === a.toolUseId;
        return (
          <div
            key={a.toolUseId}
            style={{
              marginBottom: 8,
              borderBottom: "1px solid var(--lude-im-border)",
              paddingBottom: 8,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginBottom: isOpen ? 8 : 0,
              }}
            >
              <Text
                style={{
                  fontSize: 12,
                  fontWeight: 500,
                  flex: 1,
                  cursor: "pointer",
                }}
                onClick={() => setExpandedId(isOpen ? null : a.toolUseId)}
              >
                {a.toolName}{" "}
                <Text type="secondary" style={{ fontSize: 10 }}>
                  {isOpen ? "▲" : "▼"}
                </Text>
              </Text>
              <Button size="small" danger onClick={() => onDeny(a.toolUseId)}>
                {t("tool.deny")}
              </Button>
              <Button size="small" type="primary" onClick={() => onApprove(a.toolUseId)}>
                {t("tool.approve")}
              </Button>
            </div>
            {isOpen && a.input != null && (
              <pre
                style={{
                  background: "var(--lude-im-bg-primary)",
                  padding: "8px 10px",
                  borderRadius: "var(--lude-im-radius-sm)",
                  fontSize: 11,
                  overflow: "auto",
                  maxHeight: 150,
                  margin: 0,
                  whiteSpace: "pre-wrap",
                }}
              >
                {JSON.stringify(a.input, null, 2)}
              </pre>
            )}
          </div>
        );
      })}
    </div>
  );
}
